import React from 'react';

const RequiredMark = () => {
  return <abbr title='required'>*</abbr>;
};

export default RequiredMark;
